export default {"src":"/_next/static/media/x-icon.a028d74a.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};